import useApi, { ApiOptions } from '../base/useApi';
import CardNoteDTO from '@src/adapters/dto/card/CardNoteDTO';
interface Params {
  cardId: string;
  note: CardNoteDTO;
}

interface Result {
  note: CardNoteDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/card/save_note/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveCardNoteLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveCardNoteLazy;
